export const emoji = {
  
} as const;
